import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="ui--dropdown"
export default class extends Controller {
  static targets = ["menu"]

  connect() {
    // Close when clicking outside
    this.boundClickOutside = this.clickOutside.bind(this)
    document.addEventListener("click", this.boundClickOutside)

    // Close on escape
    this.boundKeydown = this.handleKeydown.bind(this)
    document.addEventListener("keydown", this.boundKeydown)
  }

  disconnect() {
    document.removeEventListener("click", this.boundClickOutside)
    document.removeEventListener("keydown", this.boundKeydown)
  }

  toggle(event) {
    event.stopPropagation()
    
    if (this.menuTarget.classList.contains("hidden")) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    this.menuTarget.classList.remove("hidden")
  }

  close() {
    this.menuTarget.classList.add("hidden")
  }

  clickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  handleKeydown(event) {
    if (!this.menuTarget.classList.contains("hidden")) {
      switch (event.key) {
        case "Escape":
          this.close()
          break
        case "ArrowDown":
          event.preventDefault()
          this.focusNextItem()
          break
        case "ArrowUp":
          event.preventDefault()
          this.focusPreviousItem()
          break
      }
    }
  }

  focusNextItem() {
    const items = this.menuTarget.querySelectorAll('[role="menuitem"]:not([disabled])')
    const currentIndex = Array.from(items).indexOf(document.activeElement)
    const nextIndex = currentIndex < items.length - 1 ? currentIndex + 1 : 0
    items[nextIndex]?.focus()
  }

  focusPreviousItem() {
    const items = this.menuTarget.querySelectorAll('[role="menuitem"]:not([disabled])')
    const currentIndex = Array.from(items).indexOf(document.activeElement)
    const prevIndex = currentIndex > 0 ? currentIndex - 1 : items.length - 1
    items[prevIndex]?.focus()
  }
}
